// deps
import styled from "styled-components";
// internal-deps
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Button } from "@swiggy-private/dls-web-core/dist/components/Button";

const POPUP_BUTTON_WIDTH = "134px";

interface IButtonWidthProps {
    tabIndex: number;
    backGroundColor?: keyof IColors;
}

export const Container = styled.div(({ theme }) => ({
    bottom: theme.spacing.empty,
    borderTopLeftRadius: theme.spacing.large,
    borderTopRightRadius: theme.spacing.large,
    shadowOffset: {
        width: 0,
        height: 1,
    },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 1,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    boxShadow: theme.elevation[theme.colorMode].liftedNegative.boxShadow,
}));

export const ChargeHeader = styled.div(({ theme }) => ({
    padding: theme.spacing.medium,
}));

export const ButtonContainer = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    paddingLeft: theme.spacing.medium,
    paddingRight: theme.spacing.medium,
    alignItems: "center",
    alignSelf: "center",
    display: "flex",
}));

export const ButtonWidth = styled.div<IButtonWidthProps>(({ theme, tabIndex, backGroundColor }) => ({
    backgroundColor: backGroundColor,
    marginLeft: tabIndex === 0 ? 0 : theme.spacing.medium,
    borderRadius: theme.spacing.small,
    flex: 1,
}));

// /popup styles
export const CTAContainer = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    bottom: theme.spacing.empty,
    alignItems: "center",
    alignSelf: "center",
    display: "flex",
    justifyContent: "center",
}));

export const PopupButtonsContainer = styled.div(({ theme }) => ({
    borderRadius: theme.spacing.small,
    display: "flex",
    gap: theme.spacing.xLarge,
}));

export const ModalOverlay = styled.div(({ theme }) => ({
    position: "fixed",
    top: theme.spacing.empty,
    left: theme.spacing.empty,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
}));

export const ModalContent = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.spacing.large,
    padding: theme.spacing.medium,
    marginTop: theme.spacing.small,
    width: "85%",
    textAlign: "center",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
}));

export const StyledHeaderText = styled(Text)(({ theme }) => ({
    fontFamily: "Gilroy",
    fontSize: theme.spacing.large,
    fontWeight: 500,
    textAlign: "center",
    letterSpacing: 0.1,
    lineHeight: 1.2,
    marginBottom: theme.spacing.xSmall,
    maxWidth: 280,
}));

export const PopupInnerButtonsContainer = styled.div(({ theme }) => ({
    borderRadius: theme.spacing.small,
    display: "flex",
    gap: theme.spacing.small, // Reduce gap for better alignment
    justifyContent: "space-between", // Ensures buttons stay aligned
    flexWrap: "nowrap", // Prevents text wrapping within buttons
}));

export const StyledText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
}));

export const StyledButton = styled(Button)(() => ({
    width: POPUP_BUTTON_WIDTH,
}));
